import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Instagram } from "lucide-react";
import { CONTACT, HOURS, NAV_LINKS } from "@/data/content";

const SOCIALS = [
  { icon: Instagram, label: "Instagram", href: "https://instagram.com/forco_amore", id: "instagram" },
];

const Footer = () => (
  <footer id="contact" className="bg-ink text-cream/75" data-testid="site-footer">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-12 pt-24 pb-10">
      <div className="grid gap-14 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <p className="font-serif text-3xl font-medium text-cream">
            Forco <span className="italic">Amore</span>
          </p>
          <p className="mt-4 text-sm font-light leading-relaxed">Italian Soul • Indian Heart • Made With Amore</p>
          <p className="mt-2 text-xs text-cream/50 font-light tracking-wider">by {CONTACT.company}</p>
        </div>

        <div>
          <p className="text-xs tracking-[0.35em] uppercase text-brass mb-6">Explore</p>
          <ul className="space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.id}>
                {l.href.includes("#") ? (
                  <a href={l.href} data-testid={`footer-link-${l.id}`} className="text-sm font-light hover:text-cream transition-colors duration-300">
                    {l.label}
                  </a>
                ) : (
                  <Link to={l.href} data-testid={`footer-link-${l.id}`} className="text-sm font-light hover:text-cream transition-colors duration-300">
                    {l.label}
                  </Link>
                )}
              </li>
            ))}
            <li>
              <a href="/#catering" data-testid="footer-link-catering" className="text-sm font-light hover:text-cream transition-colors duration-300">
                Catering & Events
              </a>
            </li>
          </ul>
        </div>

        <div>
          <p className="text-xs tracking-[0.35em] uppercase text-brass mb-6">Contact</p>
          <ul className="space-y-4 text-sm font-light">
            <li className="flex gap-3">
              <MapPin size={16} className="mt-0.5 shrink-0 text-brass" strokeWidth={1.4} />
              <span data-testid="footer-address">{CONTACT.address}</span>
            </li>
            <li className="flex gap-3">
              <Phone size={16} className="mt-0.5 shrink-0 text-brass" strokeWidth={1.4} />
              <a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} data-testid="footer-phone" className="hover:text-cream transition-colors">{CONTACT.phone}</a>
            </li>
            <li className="flex gap-3">
              <Mail size={16} className="mt-0.5 shrink-0 text-brass" strokeWidth={1.4} />
              <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="hover:text-cream transition-colors">{CONTACT.email}</a>
            </li>
            {SOCIALS.map((s) => (
              <li key={s.id} className="flex gap-3">
                <s.icon size={16} className="mt-0.5 shrink-0 text-brass" strokeWidth={1.4} />
                <a
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  data-testid={`social-${s.id}`}
                  className="hover:text-cream transition-colors"
                >
                  @forco_amore
                </a>
              </li>
            ))}
          </ul>
          <a
            href={CONTACT.mapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-maps-link"
            className="mt-6 flex items-center justify-between gap-4 rounded-2xl border border-cream/15 p-4 hover:border-brass transition-colors duration-300"
          >
            <span className="text-xs tracking-[0.2em] uppercase">Find us on Google Maps</span>
            <MapPin size={16} className="text-brass" strokeWidth={1.4} />
          </a>
        </div>

        <div>
          <p className="text-xs tracking-[0.35em] uppercase text-brass mb-6">Opening Hours</p>
          <ul className="space-y-4 text-sm font-light" data-testid="footer-hours">
            {HOURS.map((h) => (
              <li key={h.days} className="flex flex-col">
                <span className="text-cream">{h.days}</span>
                <span className="text-cream/55">{h.time}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-16 flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-cream/10 pt-8 text-xs tracking-wider text-cream/45">
        <p>© 2026 {CONTACT.company}. All rights reserved.</p>
        <div className="flex gap-8">
          <a href="/#home" data-testid="footer-privacy-link" className="hover:text-cream transition-colors">Privacy Policy</a>
          <a href="/#home" data-testid="footer-terms-link" className="hover:text-cream transition-colors">Terms</a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
